import { EventRegistrationApiEndpoints } from "@/views/academy/eventregistration/EventRegistrationApiEndpoints";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest
} from "@/views/academy/api/apiRequests";

const REGISTRATION_EVENT_OPTION_NAME_EXISTS =
  "REGISTRATION_EVENT_OPTION_NAME_EXISTS";

const state = () => ({
  registrationOptions: []
});

const getters = {
  registrationOptions: (state: { registrationOptions: [] }) =>
    state.registrationOptions
};

const mutations = {
  setRegistrationOptions: (
    state: { registrationOptions: [] },
    payload: { registrationOptions: [] }
  ) => {
    state.registrationOptions = payload.registrationOptions;
  }
};

const actions = {
  fetchRegistrationOptions: async (
    context: any,
    payload: {
      registrationId: string;
      successCallback: Function;
    }
  ) => {
    const { registrationId, successCallback } = payload;
    try {
      const res: any = await getRequest(
        `${EventRegistrationApiEndpoints.FETCH_REGISTRATION_OPTIONS}/${registrationId}/summary`
      );
      if (res.status === "success") {
        successCallback && successCallback(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  },

  createRegistrationOption: async (
    context: any,
    payload: {
      registrationId: string;
      body: {
        name: string;
        priceInCents: number | null;
        orgUnitId: null;
        eventsIds: [];
      };
      successCallback: Function;
      failureCallback: Function;
    }
  ) => {
    const { registrationId, body, successCallback, failureCallback } = payload;

    try {
      const res: any = await postRequest(
        `${EventRegistrationApiEndpoints.CREATE_REGISTRATION_OPTION}/${registrationId}`,
        body
      );
      if (res.status === "success") {
        successCallback && successCallback(res.data);
      } else if (
        res.response.data.code === REGISTRATION_EVENT_OPTION_NAME_EXISTS
      ) {
        context.dispatch("fetchRegistrationOptions", {
          registrationId,
          successCallback: (data: any) => failureCallback(data)
        });
      }
    } catch (e) {
      console.log(e);
    }
  },

  deleteRegistrationOption: async (
    context: any,
    payload: {
      registrationId: string;
      optionId: string;
      successCallback: Function;
    }
  ) => {
    const { registrationId, optionId, successCallback } = payload;

    try {
      const res: any = await deleteRequest(
        `${EventRegistrationApiEndpoints.DELETE_REGISTRATION_OPTION}/${registrationId}/option/${optionId}`
      );
      if (res.status === "success") {
        context.dispatch("fetchRegistrationOptions", {
          registrationId,
          successCallback: (data: object) => successCallback(data)
        });
      }
    } catch (e) {
      console.log(e);
    }
  },

  updateRegistrationOption: async (
    context: any,
    payload: {
      registrationId: string;
      optionId: string;
      body: object;
      successCallback: Function;
    }
  ) => {
    const { registrationId, optionId, body, successCallback } = payload;

    try {
      const res: any = await putRequest(
        `${EventRegistrationApiEndpoints.UPDATE_REGISTRATION_OPTION}/${registrationId}/option/${optionId}`,
        body
      );
      if (res.status === "success") {
        successCallback && successCallback(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  },

  fetchRegistrationOptionEvents: async (
    context: any,
    payload: {
      registrationId: string;
      optionId: string;
      orgUnitId: string;
      successCallback: Function;
    }
  ) => {
    const { registrationId, optionId, orgUnitId, successCallback } = payload;

    try {
      const res: any = await getRequest(
        `${EventRegistrationApiEndpoints.FETCH_REGISTRATION_OPTION_EVENTS}/${registrationId}/option/${optionId}/org-unit/${orgUnitId}/summary`
      );
      if (res.status === "success") {
        successCallback && successCallback(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
